import React, { useState } from "react";
import emailjs from "emailjs-com";

function FormGetQuote() {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    products: [{ partNumber: "", qty: "", targetPrice: "" }],
  });

  // Modify this function to handle input changes
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    if (name.startsWith("product_")) {
      const updatedProducts = [...formValues.products];
      const field = name.split("_")[1]; // e.g., product_partNumber_0 -> partNumber
      updatedProducts[index][field] = value;
      setFormValues({ ...formValues, products: updatedProducts });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  // Update this function to include EmailJS functionality
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your service ID, template ID, and user ID below
    emailjs
      .send(
        "service_q63dw1a",
        "template_pc39adm",
        formValues,
        "d7avdztHAtJLl4van"
      )
      .then(
        (result) => {
          // console.log("Email sent: ", result.text);
          // Handle success (e.g., showing a success message, resetting the form)
        },
        (error) => {
          // console.log("Email error: ", error.text);
          // Handle errors here (e.g., showing an error message)
        }
      );
  };
    
  // Add a new product row
  const addProductRow = () => {
    const newProduct = { partNumber: "", qty: "", targetPrice: "" };
    setFormValues({
      ...formValues,
      products: [...formValues.products, newProduct],
    });
  };

  // Remove a product row
  const removeProductRow = (index) => {
    const filteredProducts = formValues.products.filter((_, i) => i !== index);
    setFormValues({ ...formValues, products: filteredProducts });
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-4xl mx-auto p-4">
      <div className="mb-4">
        <label
          htmlFor="name"
          className="block text-sm font-semibold text-gray-700"
        >
          Name *
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formValues.name}
          onChange={handleInputChange}
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="email"
          className="block text-sm font-semibold text-gray-700"
        >
          Email *
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formValues.email}
          onChange={handleInputChange}
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="phone"
          className="block text-sm font-semibold text-gray-700"
        >
          Phone
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formValues.phone}
          onChange={handleInputChange}
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="company"
          className="block text-sm font-semibold text-gray-700"
        >
          Company
        </label>
        <input
          type="text"
          id="company"
          name="company"
          value={formValues.company}
          onChange={handleInputChange}
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>

      <div>
        <h4 className="font-semibold">Products Required *</h4>
        {formValues.products.map((product, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end mb-4"
          >
            <div>
              <label htmlFor={`product_partNumber_${index}`}>
                Part Number:
              </label>
              <input
                type="text"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                id={`product_partNumber_${index}`}
                name={`product_partNumber_${index}`}
                value={product.partNumber}
                onChange={(e) => handleInputChange(e, index)}
                required
              />
            </div>
            <div>
              <label htmlFor={`product_qty_${index}`}>Qty Needed:</label>
              <input
                type="number"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                id={`product_qty_${index}`}
                name={`product_qty_${index}`}
                value={product.qty}
                onChange={(e) => handleInputChange(e, index)}
                required
              />
            </div>
            <div>
              <label htmlFor={`product_targetPrice_${index}`}>
                Target Price ($):
              </label>
              <input
                type="number"
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                id={`product_targetPrice_${index}`}
                name={`product_targetPrice_${index}`}
                value={product.targetPrice}
                onChange={(e) => handleInputChange(e, index)}
                required
              />
            </div>
            <div className="col-span-full">
              <button
                type="button"
                className="mt-2 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                onClick={() => removeProductRow(index)}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={addProductRow}
        >
          Add Item To Quote
        </button>
      </div>

      <div className="mt-6">
        <label
          htmlFor="message"
          className="block text-sm font-semibold text-gray-700"
        >
          Message *
        </label>
        <textarea
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          id="message"
          name="message"
          value={formValues.message}
          onChange={handleInputChange}
          required
        />
      </div>

      <button
        type="submit"
        className="mt-6 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded float-right"
      >
        Submit
      </button>
    </form>
  );
}

export default FormGetQuote;
